export default __webpack_public_path__ + "static/media/06en.fab70ce1.mp3";